import I18n from '@/i18n'

export default {

    ClientType: {
        WEBUI: 4
    },
    UserType: {
        GUEST: -1,		// 游客
        REAL: 0,		// 真实
        DEMO: 1		// 模拟
    },

    StockType: {
        Direct: 0,				// 直接货币
        InDirect: 1,			// 间接货币
        CrossDirect: 2,		// 交叉直接货币
        CrossInDirect: 3		// 交叉间接货币
    },

    /**
     * 强制踢出原因
     */
    UserForceLogout: {
        ALREADY_LOGIN: 0,		// 已經登入
        USER_DISABLE: 1,		// 用户被停用
        ACCOUNT_DISABLE: 2,	// 账户被禁用
        PWD_CHANGE: 3,			// 修改密码
        RECONNECT: 4			// 连接被重置
    },
    /**
     * 买卖方向
     */
    OrderDirection: {
        BUY: 1,    	// 买
        SELL: 2		// 卖
    },
    /**
     * 订单类型
     */
    OrderType: {
        OPEN: 1,		// 市价建仓0x01
        LIMIT: 2,		// 限价建仓0x02
        STOP: 4,		// 停损建仓0x04
        CLOSE: 8 		// 市价平仓0x08
    },
    /**
     * 过期类型
     */
    ExpireType: {
        DAY: 1,			// 当日有效
        WEEK: 2,		// 当周有效
        SPECIFIE: 3		// 指定日期
    },
    /**
     * 持仓状态
     */
    PositionStatus: {
        OPENED: 1,			// 开仓
        CLOSED: 2,			// 平仓
        CLOSING: 3,		// mt4 used when GTS2 waiting for MT4 to confirm position closed
        DEALING: 4,		// position is pending to deal by dealer on admin
        DELETED: 5,
        EOD: 6,			// 日结
        OPENING: 7,		// mt4 used when GTS2 waiting for MT4 to confirm position opened
        MAX: 8
    },
    /**
     * 订单状态
     */
    OrderStatus: {
        PLACED: 1,			// 等待
        FILLED: 2,			// 已执行
        PARTIAL_FILLED: 3,	// 不支持
        CANCELED: 4,		// 已取消
        REJECTED: 5,
        DELETED: 6
    },
    /**
     * 成交原因
     */
    DealReason: {
        OPEN: 1,			// 市价建仓0x08
        LIMIT: 2,			// 限价建仓0x02
        STOP: 4,			// 停损建仓0x04
        CLOSE: 8,			// 市价平仓0x08
        STOP_LOSS: 16,		// 止损	0x10
        TAKE_PROFIT: 32,	// 止盈	0x20
        STOP_OUT: 64,		// 强制平仓0x40
        PARTIAL_CLOSE: 128,// 部分平仓0x80
        EXPIRED: 0xA0, 	// 到期0xA0
        GROUP_CLOSE: 0xA1	// 组平仓0xA0
    },
    /**
     * 交易品种可用状态 可用状态：0-未激活；1-可用；2-不可用；3-到期；
     */
    SymbolEnable: {
        INACTIVATED: 0,	// 未激活
        ENABLED: 1,		// 可用
        DISABLED: 2,		// 不可用
        EXPIRED: 3			// 到期
    },
    /**
     * 交易品种交易状态 交易状态：0-不可交易；1-可交易；2-参考行情（不可交易）；3-仅平仓；
     */
    SymbolTradable: {
        DISABLED: 0,		// 不可交易
        TRADABLE: 1,		// 可交易
        REFERENCE: 2,		// 参考行情（不可交易）---目前admin设置的不可交易..
        CLOSEONLY: 3		// 仅平仓
    },
    /**
     * 产品分类--UI自定义区分显示
     */
    SymboCategory: {
        FX: 0,			// 外汇
        METAL: 1,		// 贵金属
        OIL: 2,		// 期货-期油
        INDEX: 3,		// 期货-期指
        REF: 4			// 参考行情
    },
    /**
     * 交易产品类型
     */
    SymboType: {
        FX: 0,			// 外汇
        METAL: 1,		// 贵金属
        CFD: 2			// 到期（期货）
    },
    /**
     * 行情产品类型
     */
    ZoneType: {
        REF: 3,		// 参考行情
        FX: 2,			// 外汇
        METAL: 1,		// 贵金属
        OIL: 4,		// 期油
        INDEX: 5		// 期指
    },
    Lang: {
        zh_CN: 'zh_CN',
        zh_TW: 'zh_TW',
        en_US: 'en_US'
    },
    /**
     * 币种-显示单位
     */
    Currency: {
        USD: '$',
        CNY: '¥'
    },
    FundsMask: '****',

    Req: {
        quoteQuery: '0x10301',		//历史行情报价
        quoteMin: '0x10305',        //分时图数据
        lastTick: '0x10303',		//最后一口报价
        subsTick: '0x10304',		//行情订阅

        logoutServer: '0x1315',	//登出交易服务器
        serverTime: '0x100D',		//交易服务器系统时间
        serverGet: '0x1004',		//交易服务器信息
        tradeTimes: '0x120C',		//交易时间列表
        holidays: '0x1C05',		//假期数据
        marginLevels: '0x1224',	//层级保证金列表

        symbols: '0x1208',			//交易品种列表（产品列表）
        pendings: '0x1705',		//挂单记录
        deals: '0x1807',			//当日成交记录
        positions: '0x1905',		//持仓记录
        openOrder: '0x1701',		//开仓（市价、挂单）、平仓(市价
        modifyOrder: '0x1702',		//改单（挂单）
        cancelOrder: '0x1709',		//撤单
        profitloss: '0x1902'		//设置止损止盈
    },

    WebUIError: {
        //server side
        "-1": 'webUiError.negativeOne',
        1: 'webUiError.error1',
        2: 'webUiError.error2',
        3: 'webUiError.error2',
        4: 'webUiError.error4',
        5: 'webUiError.error5',
        6: 'webUiError.error5',
        7: 'webUiError.error5',
        8: 'webUiError.error5',
        9: 'webUiError.error5',
        10: 'webUiError.error5',
        11: 'webUiError.error5',
        12: 'webUiError.error12',
        13: 'webUiError.error13',
        14: 'webUiError.error14',
        15: 'webUiError.error15',
        16: 'webUiError.error16',
        17: 'webUiError.error17',
        18: 'webUiError.error18',
        19: 'webUiError.error19',
        20: 'webUiError.error19',
        21: 'webUiError.error19',
        22: 'webUiError.error19',
        23: 'webUiError.error19',
        24: 'webUiError.error24',
        25: 'webUiError.error5',
        26: 'webUiError.error5',
        27: 'webUiError.error5',
        28: 'webUiError.error5',
        29: 'webUiError.error5',
        30: 'webUiError.error5',
        31: 'webUiError.error5',
        32: 'webUiError.error5',
        33: 'webUiError.error5',
        34: 'webUiError.error5',
        35: 'webUiError.error5',
        36: 'webUiError.error5',
        37: 'webUiError.error5',
        38: 'webUiError.error38',
        39: 'webUiError.error39',
        40: 'webUiError.error5',
        41: 'webUiError.error5',
        42: 'webUiError.error24',
        43: 'webUiError.error5',
        44: 'webUiError.error5',
        45: 'webUiError.error5',
        46: 'webUiError.error5',
        47: 'webUiError.error5',
        48: 'webUiError.error5',
        49: 'webUiError.error5',
        50: 'webUiError.error50',
        51: 'webUiError.error5',
        52: 'webUiError.error5',
        53: 'webUiError.error5',
        54: 'webUiError.error54',
        55: 'webUiError.error55',
        56: 'webUiError.error56',
        57: 'webUiError.error5',
        58: 'webUiError.error5',
        59: 'webUiError.error59',
        60: 'webUiError.error19',
        61: 'webUiError.error5',
        62: 'webUiError.error62',
        63: 'webUiError.error62',
        64: 'webUiError.error64',
        65: 'webUiError.error65',
        66: 'webUiError.error5',
        67: 'webUiError.error67',
        68: 'webUiError.error5',
        69: 'webUiError.error5',
        70: 'webUiError.error70',
        71: 'webUiError.error70',
        72: 'webUiError.error5',//持仓已关闭
        73: 'webUiError.error73',
        74: 'webUiError.error74',
        75: 'webUiError.error75',
        76: 'webUiError.error5',
        77: 'webUiError.error5',
        78: 'webUiError.error19',
        79: 'webUiError.error19',
        80: 'webUiError.error19',
        81: 'webUiError.error5',
        82: 'webUiError.error5',
        83: 'webUiError.error83',
        84: 'webUiError.error75',
        85: 'webUiError.error75',
        86: 'webUiError.error75',
        87: 'webUiError.error87',
        88: 'webUiError.error19',
        89: 'webUiError.error89',
        90: 'webUiError.error5',
        91: 'webUiError.error5',
        92: 'webUiError.error5',
        93: 'webUiError.error19',//行情的報價超時或者沒有收到行情報價
        94: 'webUiError.error94',
        95: 'webUiError.error94',
        96: 'webUiError.error96',
        97: 'webUiError.error94',
        98: 'webUiError.error87',
        99: 'webUiError.error96',
        100: 'webUiError.error5',
        102: 'webUiError.error62',
        103: 'webUiError.error103',
        104: 'webUiError.error104',
        105: 'webUiError.error104',
        107: 'webUiError.error107',
        108: 'webUiError.error108',	// RET_CLOSEONLY_GROUP_SYMBOL
        109: 'webUiError.error108',	// RET_CLOSEONLY_GLOBAL_SYMBOL
        110: 'webUiError.error110',
        111: 'webUiError.error110',
        112: 'webUiError.error112',
    },
};
